import { Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { get } from 'lodash';
import { useLocalStorage } from 'usehooks-ts';

import * as routes from 'router/routes';
import { LOGIN_QUERY_KEY } from 'constants/auth';
import { LOCAL_STORAGE_KEY, STRING_STORAGE_VALUE_OPTIONS } from 'constants/localStorage';
import { useQuery } from 'hooks/useQuery';
import { FullScreenLoader } from 'layouts';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const query = useQuery();
  const token = query.get(LOGIN_QUERY_KEY.ACCESS);
  const refresh = query.get(LOGIN_QUERY_KEY.REFRESH);

  const [authToken, setAuthToken] = useLocalStorage(LOCAL_STORAGE_KEY.AUTH_TOKEN, null, STRING_STORAGE_VALUE_OPTIONS);
  const [, setRefreshToken] = useLocalStorage(LOCAL_STORAGE_KEY.REFRESH_TOKEN, null, STRING_STORAGE_VALUE_OPTIONS);
  const [, , removeFromLocation] = useLocalStorage(LOCAL_STORAGE_KEY.FROM_LOCATION, null);

  useEffect(() => {
    // for SSO login purposes
    if (get(rest, ['location', 'state', 'isLoginRedirect'], false)) {
      removeFromLocation();
      window.history.replaceState({}, '');
    }
  }, [removeFromLocation, rest]);

  useEffect(() => {
    if (token && refresh) {
      setAuthToken(token);
      setRefreshToken(refresh);
    }
  }, [refresh, setAuthToken, setRefreshToken, token]);

  return (
    <Route
      {...rest}
      exact
      render={(props) =>
        !authToken ? (
          <Redirect
            to={{
              pathname: routes.loginScreen,
              state: { from: props.location },
            }}
          />
        ) : (
          <Suspense key={rest.path} fallback={<FullScreenLoader />}>
            <Component {...props} />
          </Suspense>
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.any]).isRequired,
  location: PropTypes.shape({}),
};

export default PrivateRoute;
